<template>
  <div class="centerPage">
    <div class="pageTit">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/drug/list' }">药物管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/drug/categoryList' }">药物类别管理</el-breadcrumb-item>
        <el-breadcrumb-item>药物类别{{ categoryId ? '编辑' : '新增' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form ref="form" class="article_edit" label-width="100px">
      <el-form-item label="中文名：">
        <el-input v-model="categoryData.cnName" placeholder="请输入中文名">
        </el-input>
      </el-form-item>
      <el-form-item label="英文名：">
        <el-input v-model="categoryData.enName" placeholder="请输入英文名">
        </el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-radio-group v-model="categoryData.status" class="type">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序：" v-if="categoryData.sort">
        {{ categoryData.sort }}
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="categoryData.remark" placeholder="请输入备注" :autosize="{ minRows: 2, maxRows: 5}"
                  type="textarea">
        </el-input>
      </el-form-item>
      <div class="btn">
        <el-button @click="saveUpdate" v-if="categoryId">更新</el-button>
        <el-button @click="saveUpdate" v-else>添加</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "categoryEdit",
  data() {
    return {
      categoryData: {
        cnName: '',
        enName: '',
        status: 1,
        remark: '',
      },
      categoryId: this.$route.query.id,//药物类别id
    }
  },
  mounted() {
    if (this.categoryId != null) {
      this.getCategory();
    }
  },
  methods: {
    getCategory() {
      let that = this;
      if (that.catalogId == '0') {
        return;
      }
      this.$ajax
          .post(commonjs.api.drug.edit.category.detail.replace("{categoryId}", this.categoryId))
          .then(function (res) {
            if (res.data.status === 'success') {
              that.categoryData = res.data.data;
            } else {
              that.$message.error('error')
            }
          });
    },
    saveUpdate() {
      let that = this;
      this.$ajax
          .post(commonjs.api.drug.edit.category.saveUpdate.replace("{categoryId}", this.categoryId), this.categoryData)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.$message({
                message: res.data.message,
                type: 'success'
              })
            } else {
              that.$message.error(res.data.message);
            }
            that.$router.push({name: 'categoryList'});
          }).catch((err) => {
        console.error(err);
        that.$message.error('操作失败')
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/banner.scss';

.centerPage {
  display: block;
  width: auto;

  ::v-deep .el-form-item {
    display: block;

    .el-form-item__label {
      width: auto;
    }
  }

  ::v-deep .el-form-item__content {
    width: 80%;

    .el-checkbox {
      min-width: 12%;
      height: 27px;
      line-height: 27px;
      font-size: 13px;
      color: #999999;

      ::v-deep .el-checkbox__inner {
        width: 13px;
        height: 13px;
        border: 1px solid #999999;
        border-radius: 2px;
      }
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #567BFF;
      border-color: #567BFF;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #999999;
    }
  }
}


.ql-snow .ql-color-picker, .ql-snow .ql-picker.ql-header {
  line-height: 24px;
}

.flip-list-move {
  transition: transform 1s;
}

.items {
  width: 300px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 1px solid red;
}
</style>